module.exports = __webpack_public_path__ + "img/147-bangladesh.91c34273.svg";